import React from "react";
import { useState, useEffect } from "react";
import AuthService from "../services/auth.service";
import api from "../services/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import WeightChart2 from "../components/veauHub/WeightChart";
import WeightForm from "./forms/WeightForm";
import WeightPreview from "./WeightPreview";
import WeightDetail from "./WeightDetail";
import Modal from "./UI/Modal";
function Weights(props) {
  const [weights, setWeights] = useState([]);
  const [weightsChart, setWeightsChart] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  let [isCreateModalOpen, setisCreateModaleOpen] = useState(false);
  let [isUpdateModalOpen, setisUpdateModalOpen] = useState(false);
  let [selectedWeight, setSelectedWeight] = useState(0);
  function closeCreateModal() {
    setisCreateModaleOpen(false);
  }

  function openCreateModal() {
    setisCreateModaleOpen(true);
  }
  function closeUpdateModal() {
    setisUpdateModalOpen(false);
  }

  let { calfId } = useParams();
  const getWeights = () => {
    api
      .get("/weight/calf/" + calfId)
      .then((response) => {
        const data = response.data;
        setWeights(data);
        let chartData = [];
        data.forEach((weight) => {
          chartData.push({ x: new Date(weight.date), y: weight.weight });
        });
        setWeightsChart(chartData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error getting the weights!", error);
        setLoading(false);
      });
  };
  const refresh = () => {
    setWeights([]);
    getWeights();
  };
  useEffect(() => {
    //Runs only on the first render
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) {
      navigate("/login");
    } else {
      getWeights();
    }
  }, []);
  if (isLoading) {
    return <div></div>;
  }
  return (
    <div className=" md:bg-white dark:md:bg-slate-900">
      <div className={weights.length === 0 ? "hidden" : ""}>
        <WeightChart2 weights={weightsChart}></WeightChart2>
        <div className={"flex flex-row justify-end md:hidden"}>
          <Link to={"/poids/" + calfId}>
            <span className="font-medium text-amber-500 dark:text-amber-400">Ajouter un poids</span>
          </Link>
        </div>
        <div
          className={
            "mt-3 w-full overflow-visible rounded-lg border-stone-200 bg-white md:mt-6 md:border md:shadow dark:border-slate-700 dark:bg-slate-900 "
          }
        >
          <div className="mb-3 hidden justify-between rounded-t-md border-b border-stone-200  p-6 text-stone-800 md:flex dark:border-slate-700 dark:text-white">
            <span className="text-lg font-semibold">Liste des poids</span>
            <button
              onClick={openCreateModal}
              className="flex items-center rounded-lg border border-stone-200 px-3 py-2 text-sm text-stone-800 shadow transition-all duration-100 hover:-translate-y-[2px] hover:shadow-lg dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="mr-2 h-4 w-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>

              <span>Ajouter</span>
            </button>
          </div>
          {weights.map((weight, index) => (
            <WeightPreview
              key={"weight_" + index}
              calfID={calfId}
              weight={weight}
              index={index}
              listLength={weights.length}
              setisUpdateModalOpen={setisUpdateModalOpen}
              setSelectedWeight={setSelectedWeight}
            ></WeightPreview>
          ))}
        </div>
      </div>
      <div
        className={
          "mt-3 flex flex-col items-center justify-center " +
          (weights.length > 0 ? "hidden" : "")
        }
      >
        <div>
          <span className="font-semibold dark:text-white">Aucune poids enregistré</span>
        </div>
        <p className="my-3 text-center text-sm text-stone-400 dark:text-slate-400">
          Vous n'avez encore enregistré aucun poids pour ce veau. Cliquer sur
          "Ajouter un poid" pour commencer !
        </p>
        <Link to={"/poids/" + calfId}>
          <button className="rounded-lg bg-amber-400 py-1 px-3 text-white dark:bg-amber-500 dark:hover:bg-amber-600">
            Ajouter un poids
          </button>
        </Link>
      </div>
      <Modal
        open={isCreateModalOpen}
        onClose={closeCreateModal}
        title="Ajouter un poids"
      >
        <WeightForm
          calfID={calfId}
          onDone={() => {
            closeCreateModal();
            refresh();
          }}
          onCancel={closeCreateModal}
        />
      </Modal>

      <Modal
        open={isUpdateModalOpen}
        onClose={closeUpdateModal}
        title="Détail de la pesée"
      >
        <WeightDetail
          weightId={selectedWeight}
          onDeleted={() => {
            closeUpdateModal();
            refresh();
          }}
        />
      </Modal>
    </div>
  );
}

export default Weights;
